module.exports = __webpack_public_path__ + "static/media/money-frozen.b7935ee3.png";